import ButtonChangeRegions from './button-change-regions';

export default class UndefineRegions {
    constructor(selector) {
        this.button = document.querySelectorAll(selector);
        this.button.forEach((btn) => {
            new ButtonChangeRegions(btn);
        });
        this.undefineRegion = document?.querySelectorAll('.modal-regions-undefined');
        this.buttonClose = this.undefineRegion;

        this.checkSelectedRegion();
        this.eventRegister();
    }

    eventRegister() {
        if (this.undefineRegion) {
            this.undefineRegion.forEach((item) => {
                const closeBtn = item.querySelector('.modal-regions-undefined__close');
                if (!closeBtn) return;
                closeBtn.addEventListener('click', () => {
                    this.closeModalUndefine(item);
                });
            });
        }
    }
    checkSelectedRegion() {
        const isRegionSelected = document.cookie.split('; ').some((item) => item.startsWith('current_region='));
        if (isRegionSelected) {
            return;
        }
        this.undefineRegion.forEach((item) => {
            item.style.display = 'flex';
        });
    }
    closeModalUndefine(modal) {
        if (modal) {
            modal.style.display = 'none';
        }
    }
}
